<script setup lang="ts">
import InputSwitch from 'primevue/inputswitch';
import { useAppConfigStore } from '../stores/app-config-store';

const configStore = useAppConfigStore();
</script>

<template>
    <InputSwitch
        v-model="configStore.ripple"
        class="app-layout-ripple-switch"
    />
</template>
